import { useState } from 'react'
import { Save } from '@icon-park/react'
import { Tokens } from '@/assets/tokens'
import { Button, Input } from '@/components'
import { useRouting } from '@/hooks'
import { Alert, Api } from '@/modules'
import { BaseModal } from '../Modal/Modal.component'
import {
  ActionButton,
  ButtonContainer,
  FormContainer,
  InfoText,
  FilterDetailsContainer,
  FilterDetailsTitle,
  FilterDetailsList,
  FilterTag,
  EmptyFiltersMessage,
} from './FilterModal.styles'
import { getFilterDetails } from './FilterDetailsHelper'

interface SaveFilterModalProps {
  isOpen: boolean
  onClose: () => void
  currentConfig: Record<string, any>
  filterType: 'MENTION' | 'DASHBOARD'
}

export function SaveFilterModal({ isOpen, onClose, currentConfig, filterType }: SaveFilterModalProps) {
  const [name, setName] = useState('')
  const { companyID } = useRouting()
  const { sendAlert } = Alert.Hook()

  const { isRunning: isSaving, run: saveFilterConfig } = Api.Command(
    Api.Methods.POST,
    `companies/${companyID}/filter-configs`,
  )

  const filterDetails = getFilterDetails(currentConfig, filterType)

  const handleSave = () => {
    if (!name.trim()) {
      sendAlert({
        type: 'error',
        title: 'Nome obrigatório',
        message: 'Por favor, digite um nome para a configuração.',
      })
      return
    }

    if (!companyID) {
      sendAlert({
        type: 'error',
        title: 'Erro',
        message: 'Empresa não identificada.',
      })
      return
    }

    saveFilterConfig({
      input: {
        name: name.trim(),
        type: filterType,
        parameters: currentConfig,
      },
      onSuccess: () => {
        sendAlert({
          type: 'success',
          title: 'Configuração salva',
          message: `A configuração "${name}" foi salva com sucesso.`,
        })
        onClose()
      },
      onFail: (error) => {
        sendAlert({
          type: 'error',
          title: 'Erro ao salvar',
          message: `Não foi possível salvar a configuração: ${error.message}`,
        })
      },
    })
  }

  return (
    <BaseModal isOpen={isOpen} onClose={onClose} title="Salvar Configuração de Filtro">
      <FormContainer>
        <Input
          label="Nome da configuração"
          placeholder="Digite um nome para salvar esta configuração"
          value={name}
          onChange={setName}
          required
        />

        <FilterDetailsContainer>
          <FilterDetailsTitle>Detalhes do Filtro:</FilterDetailsTitle>
          {filterDetails.length > 0 ?
            <FilterDetailsList>
              {filterDetails.map((detail, index) => (
                <FilterTag key={index}>{detail}</FilterTag>
              ))}
            </FilterDetailsList>
          : <EmptyFiltersMessage>Nenhum filtro aplicado</EmptyFiltersMessage>}
        </FilterDetailsContainer>

        <InfoText>Se já existir uma configuração com este nome, ela será atualizada.</InfoText>
      </FormContainer>

      <ButtonContainer>
        <ActionButton>
          <Button.Root $variant="secondary" onClick={onClose}>
            <Button.Text value="Cancelar" />
          </Button.Root>
        </ActionButton>
        <ActionButton>
          <Button.Root $variant="primary" onClick={handleSave} $loading={isSaving} disabled={!name.trim()}>
            <Button.Icon value={Save} color={Tokens.ColorWhite} />
            <Button.Text value="Salvar" />
          </Button.Root>
        </ActionButton>
      </ButtonContainer>
    </BaseModal>
  )
}
